// extracted by mini-css-extract-plugin
module.exports = {"container":"AlertList-module--container--1xlIU","heading":"AlertList-module--heading--3KykG","header":"AlertList-module--header--m9qaD","spacer":"AlertList-module--spacer--1goug"};